<template>
  <v-col class="v-col-6">
    <b class="text-color-0">Carteira Digital</b>
  </v-col>
  <v-col class="v-col-6 text-end">
    <v-skeleton-loader :loading="loadingCarteira" type="text" class="justify-end no-margin">
      <span class="text-color-0">Saldo:</span><b class="ms-2 text-color-1">{{ $formatNumber(getSaldoCarteira, {style: 'currency', currency: 'BRL'}) }}</b>
    </v-skeleton-loader>
  </v-col>
  <v-col class="v-col-12 pt-1">
    <v-text-field variant="outlined" v-model.lazy="carteira" v-money="money" hide-details>
      <template v-slot:append>
        <v-btn class="bg-color-2 text-color-white" variant="tonal" block size="x-large" @click="setValor()">
          Usar
        </v-btn>
      </template>
    </v-text-field>
  </v-col>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { VMoney } from 'v-money';
export default {
  name: 'CarteiraDigital',
  directives: { money: VMoney },
  data(){
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      carteira: ""
    }
  },
  computed: {
    ...mapGetters('carteira', {
      getSaldoCarteira: 'getSaldoCarteira'
    }),
    ...mapGetters('order', {
      getWalletValue: 'getWalletValue'
    }),
    ...mapGetters('cart', {
      getTotalValueCart: 'getTotalValueCart'
    }),
    ...mapState('carteira', {
      loadingCarteira: 'loadingCarteira'
    }),
  },
  watch: {
    getWalletValue: function(data){
      this.carteira = parseFloat(data).toFixed(2);
    }
  },
  methods: {
    ...mapActions('order', {
      setWalletValue: 'setWalletValue'
    }),
    setValor(){
      let wallet_value = this.carteira != '' && this.carteira != undefined ? parseFloat(this.carteira.replace("R$ ", "").replace(",", ".")): 0;
      if(wallet_value > this.getSaldoCarteira){
        this.emitter.emit('dialogMessage', { title: "Atenção!", message: "O valor informado é maior que seu saldo disponível!"});
        this.carteira = "";
      } else if (wallet_value > parseFloat(this.getTotalValueCart)){
        this.emitter.emit('dialogMessage', { title: "Atenção!", message: "O valor informado é maior que o valor total do pedido!"});
        this.carteira = "";
      } else {
        this.setWalletValue(wallet_value);
      }
    }
  },
  mounted(){
    this.carteira = parseFloat(this.getWalletValue).toFixed(2);
  }
}
</script>